import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface CurrencyStore {
  profileCurrency: string;
  updateCurrency: (newCurrency: string) => void;
}

export const useCurrencyStore = create<CurrencyStore>()(
  devtools(
    persist(
      (set) => ({
        profileCurrency: '$',
        updateCurrency: (newCurrency) => set({ profileCurrency: newCurrency })
      }),
      {
        name: 'profile-currency',
        storage: createJSONStorage(() => localStorage)
      }
    )
  )
);
